import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-d-flex p-jc-between p-ai-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "p-m-0" }, "Banners", -1)
const _hoisted_3 = { class: "p-input-icon-left" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_5 = {
  key: 0,
  class: "row"
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" No hay banners todavía. ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Buscando los banners que tengamos definidos, en breve se los mostraré. ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectButton = _resolveComponent("SelectButton")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_SiteBannerPreview = _resolveComponent("SiteBannerPreview")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_EditBannerDialog = _resolveComponent("EditBannerDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_DataTable, {
      value: _ctx.banners,
      paginator: true,
      rows: 10,
      expandedRows: _ctx.expandedRows,
      "onUpdate:expandedRows": _cache[3] || (_cache[3] = ($event: any) => (_ctx.expandedRows = $event)),
      selection: _ctx.selectedRows,
      "onUpdate:selection": _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectedRows = $event)),
      dataKey: "id",
      rowHover: true,
      loading: _ctx.loading,
      paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
      rowsPerPageOptions: [10,25,50],
      currentPageReportTemplate: "Viendo {first} a {last} de {totalRecords} banners",
      globalFilterFields: ['name', 'content'],
      filters: _ctx.filters,
      "onUpdate:filters": _cache[5] || (_cache[5] = ($event: any) => (_ctx.filters = $event)),
      showGridlines: "",
      responsiveLayout: "scroll",
      selectionMode: "multiple"
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", null, [
            _createVNode(_component_SelectButton, {
              modelValue: _ctx.filters['context'].value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.filters['context'].value = $event)),
              options: _ctx.allContexts,
              "option-label": "label",
              "option-value": "value"
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("span", _hoisted_3, [
              _hoisted_4,
              _createVNode(_component_InputText, {
                modelValue: _ctx.filters['global'].value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filters['global'].value = $event)),
                placeholder: "Buscar ..."
              }, null, 8, ["modelValue"])
            ]),
            _createVNode(_component_Button, {
              icon: "pi pi-plus-circle",
              class: "p-button-rounded p-button-text p-ml-1",
              onClick: _ctx.addNew
            }, null, 8, ["onClick"]),
            _createVNode(_component_Button, {
              icon: _ctx.showPreview ? 'pi pi-eye' : 'pi pi-eye-slash',
              class: "p-button-rounded p-button-text p-ml-1",
              onClick: _ctx.switchPreview
            }, null, 8, ["icon", "onClick"])
          ])
        ]),
        (_ctx.selectedRows.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_Button, {
                type: "button",
                icon: "pi pi-trash",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onRemoveSelection())),
                class: "p-mr-1"
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      empty: _withCtx(() => [
        _hoisted_6
      ]),
      loading: _withCtx(() => [
        _hoisted_7
      ]),
      expansion: _withCtx(({ data: banner }) => [
        _createVNode(_component_SiteBannerPreview, { banner: banner }, null, 8, ["banner"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_Column, {
          expander: true,
          headerStyle: "width: 3rem"
        }),
        _createVNode(_component_Column, { selectionMode: "multiple" }),
        _createVNode(_component_Column, {
          header: "Nombre",
          sortable: "",
          field: "name"
        }),
        _createVNode(_component_Column, {
          header: "Habilitado",
          field: "enabled"
        }, {
          body: _withCtx(({ data }) => [
            _createTextVNode(_toDisplayString(data.enabled ? 'Sí' : 'no'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          header: "Countdown",
          field: "enabled"
        }, {
          body: _withCtx(({ data }) => [
            _createTextVNode(_toDisplayString(data.showCountdown ? 'Sí' : 'no'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          header: "Desde",
          sortable: "",
          field: "active.from"
        }),
        _createVNode(_component_Column, {
          header: "Hasta",
          sortable: "",
          field: "active.to"
        }),
        _createVNode(_component_Column, {
          headerStyle: "width: 12rem; text-align: center",
          bodyStyle: "text-align: center; overflow: visible"
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_component_Button, {
              type: "button",
              icon: "pi pi-trash",
              onClick: ($event: any) => (_ctx.onRemove(data)),
              class: "p-mr-1"
            }, null, 8, ["onClick"]),
            _createVNode(_component_Button, {
              type: "button",
              icon: "pi pi-pencil",
              onClick: ($event: any) => (_ctx.onEdit(data)),
              class: "p-mr-1"
            }, null, 8, ["onClick"]),
            ((data.context === _ctx.SiteBannerContext.WWW))
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  type: "button",
                  icon: "pi pi-external-link",
                  onClick: ($event: any) => (_ctx.onOpenTest(data)),
                  class: "p-mr-1"
                }, null, 8, ["onClick"]))
              : _createCommentVNode("", true),
            _createVNode(_component_Button, {
              type: "button",
              icon: "pi pi-copy",
              onClick: ($event: any) => (_ctx.onDuplicate(data)),
              class: "p-mr-1"
            }, null, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value", "expandedRows", "selection", "loading", "filters"]),
    (_ctx.showEditDialog)
      ? (_openBlock(), _createBlock(_component_EditBannerDialog, {
          key: 0,
          banner: _ctx.editingBanner,
          show: _ctx.showEditDialog,
          onOnCancel: _ctx.onCancelEditDialog,
          onOnSave: _ctx.onSaveBanner,
          onOnOpenTest: _ctx.onOpenTest,
          categories: _ctx.categories,
          products: _ctx.products
        }, null, 8, ["banner", "show", "onOnCancel", "onOnSave", "onOnOpenTest", "categories", "products"]))
      : _createCommentVNode("", true)
  ], 64))
}